// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cubone: PokeData = {
  "id": 104,
  "name": "cubone",
  "height": 4,
  "weight": 65,
  "base_experience": 64,
  "types": [
    PokeType.GROUND
  ],
  "api_moves": [
    "headbutt",
    "thrash",
    "double-edge",
    "tail-whip",
    "leer",
    "growl",
    "rage",
    "focus-energy",
    "bone-club",
    "bonemerang",
    "mud-slap",
    "bone-rush",
    "false-swipe",
    "endeavor",
    "fling",
    "retaliate",
    "stomping-tantrum"
  ],
  "moves": [
    "headbutt",
    "leer",
    "growl",
    "bonemerang",
    "mud-slap",
    "mud-shot",
    "earthquake",
    "fissure",
    "mud-bomb",
    "bone-throw",
    "magnitude",
    "earth-power",
    "sandstorm"
  ],
  "evolution_chain": {
    "id": 46,
    "item": null,
    "species": [
      {
        "name": "cubone",
        "order": 113,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "marowak",
        "order": 114,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": 104,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "marowak-alola",
        "order": 114,
        "types": [
          PokeType.FIRE,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 104,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": {
              "name": "alola"
            },
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 61.25,
    "speed": 35,
    "ability_power": 50
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
